define('app/views/message_view',['app/setup'], function(takhfifan) {

  takhfifan.MessageView = Backbone.View.extend({
    el: $('#tkh-popup-message-container'),

    events: {
      'click .message': 'close'
    },

    close: function() {
      this.$el.find('.message').fadeOut(2000);
    },

    show: function(options) {
      var that = this;
      var msg = options.msg || '';
      var classes = options.classes || 'alert-error error';

      var msg_template = _.template($('#message-template').html());
      this.$el.find('.message').remove();
      this.$el.html(msg_template({ msg: msg, classes: classes }));
      setTimeout(function(){
        that.$el.find('.message').fadeOut(2000);
      }, 5000);
    },

    showSessionMessages: function(options) {
      var _this = this;
      _this.$el.find('.message').remove();
      var value = options[options.length-1];
      var msg = value.message || '';
      var iconClasses = 'icon-error';
      var msg_template = _.template($('#message-template').html());
      switch(value.type)
      {
        case "error":
          iconClasses = 'icon-error red';break;
        case "notice":
          iconClasses = 'icon-info blue';break;
        case "success":
          iconClasses = 'icon-check green';break;
        case "warning":
          iconClasses = 'icon-warning orange';break;
      }
      _this.$el.find('#tkh-popup-message-internal').html(msg_template({ msg: msg, iconClasses: iconClasses}));
      takhfifan.eventHub.trigger('modal:showWithTimeout',
         {timeOut:3500,fadeTimeOut:200,fadeTimeIn:400,elementToOperate:_this.$el});
    },

    initialize: function(options) {
      var that = this;
      options.document.ajaxSuccess(function(event,xhr,settings) {
        if(!_.isUndefined(xhr.responseJSON)) {
          var responseJSON = xhr.responseJSON;
          if(!_.isUndefined(responseJSON.session_messages) &&
            responseJSON.session_messages.length > 0) {
              that.showSessionMessages(responseJSON.session_messages);
          }
        }
      });
      takhfifan.eventHub.on('message:show', function(options) {
        var obj = [];
        var message = {};
        message.message = options.msg;
        message.type= options.type;
        obj.push(message);
        that.showSessionMessages(obj);
      }, this);
    }

  });

});

